export const SORT_OPERATOR_ENUM = {
    DESCENDING: { label: "descendant", value: "DESCENDING" },
    ASCENDING: { label: "ascendant", value: "ASCENDING" }
};